import { uiRows } from './types-def.js';
/**
 * `web/foundry` (2.I-2; CS r6c deliverable 205), due at exit-2c: the Foundry actor import (upload,
 * preview, identity, SRD choice, apply or reject) and the refresh of an imported character (the
 * diff, the choices, Undo, the history, the macro and the remembered world).
 */
export const FOUNDRY_INTERACTIONS = uiRows([
    {
        id: 'foundry.import.open',
        module: 'web/foundry',
        behavior: 'The sidebar entry and the Settings button open the Foundry import page',
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.import.drop',
        module: 'web/foundry',
        behavior: 'Dropping or choosing an export file uploads it and lists each actor it previews',
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.preview.type',
        module: 'web/foundry',
        behavior: "A previewed actor's type button opens a menu of the types it may be imported as",
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.identity.decide',
        module: 'web/foundry',
        behavior: 'A matched actor is confirmed, pointed at another page or imported as new',
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.srd.choose',
        module: 'web/foundry',
        behavior: 'An unchanged SRD creature is linked to its reference page or copied as a variant',
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.import.apply',
        module: 'web/foundry',
        behavior: 'Apply writes the previewed actor with the choices shown and opens its page',
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.import.reject',
        module: 'web/foundry',
        behavior: 'Reject drops a previewed actor without writing a page or a sheet',
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.biography.add',
        module: 'web/foundry',
        behavior: "An applied actor's Foundry biography is added to its page on request",
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.refresh.open',
        module: 'web/foundry',
        behavior: "The header's refresh pill opens the refresh of the page's newest import",
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.refresh.choose',
        module: 'web/foundry',
        behavior: 'Each changed value keeps the sheet or takes Foundry, one row or all at once',
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.refresh.undo',
        module: 'web/foundry',
        behavior: 'Undo restores the sheet as it was before the newest applied import',
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.history.open',
        module: 'web/foundry',
        behavior: "The history lists the page's imports, newest first, each with its outcome",
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.macro.download',
        module: 'web/foundry',
        behavior: 'The macro link downloads the export macro for Foundry',
        owner: '2.I-2',
        since: 'exit-2c',
    },
    {
        id: 'foundry.world.clear',
        module: 'web/foundry',
        behavior: 'Clearing the remembered Foundry world lets the next file name another',
        owner: '2.I-2',
        since: 'exit-2c',
    },
]);
//# sourceMappingURL=foundry.js.map